// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i0UW","left":"styles_left__3hgjV","desktopActions":"styles_desktopActions__2NNzd","title":"styles_title__1WsZ1"};